import { Controller } from "@hotwired/stimulus";
import consumer from "../channels/consumer";

export default class extends Controller {
  connect() {
    // Subscribe to super admin dashboard channel
    this.subscription = consumer.subscriptions.create(
      { channel: "SuperAdminDashboardChannel" },
      {
        received: (_data) => {
          this.handleMessage();
        },
        connected: () => {
          this.updateTimestamp();
        },
        disconnected: () => {
          // Connection closed
        }
      }
    );

    // Update timestamp every minute
    this.timestampInterval = setInterval(() => {
      this.updateTimestamp();
    }, 60000);
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.timestampInterval) {
      clearInterval(this.timestampInterval);
    }
  }

  handleMessage() {
    // Turbo Streams will handle DOM updates automatically
    this.updateTimestamp();
  }

  updateTimestamp() {
    const el = document.getElementById("last-updated");
    if (el) {
      const now = new Date();
      el.textContent = now.toLocaleTimeString();
    }
  }

  switchTab(event) {
    const tab = event.currentTarget.dataset.tab;
    if (!tab) return;

    this.element.querySelectorAll(".tab-content").forEach(el => el.classList.add("hidden"));
    this.element.querySelectorAll(".tab-button").forEach(el => {
      el.classList.remove("border-emerald-500", "text-emerald-600", "dark:text-emerald-400");
      el.classList.add("border-transparent", "text-gray-500", "dark:text-gray-400");
    });

    this.element.querySelector(`#content-${tab}`)?.classList.remove("hidden");
    event.currentTarget.classList.remove("border-transparent", "text-gray-500", "dark:text-gray-400");
    event.currentTarget.classList.add("border-emerald-500", "text-emerald-600", "dark:text-emerald-400");
  }
}
